import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React, { useState, useRef, useEffect } from "react";
import { faChevronDown, faChevronUp, faXmark } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../../AwesomeIcon";
import { useDropdownScroll } from "../hooks/useDropdownScroll";
import classNames from "classnames";
import { getInputBorderAndBackgroundClasses } from "../../../utils/fieldValidation";
var MultiSelectInput = function MultiSelectInput(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    options = _ref.options,
    onChange = _ref.onChange,
    onOpenChange = _ref.onOpenChange,
    disabled = _ref.disabled,
    isEmpty = _ref.isEmpty,
    isRequired = _ref.isRequired,
    errorMessage = _ref.errorMessage,
    isShouldBeBlankError = _ref.isShouldBeBlankError;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var containerRef = useRef(null);

  // Ensure value is always an array of strings (convert numbers to strings for consistency)
  var safeValue = Array.isArray(value) ? value.map(function (v) {
    return String(v);
  }) : value ? [String(value)] : [];
  var shouldShowServerError = !isEmpty && !!errorMessage;
  var borderAndBackgroundClasses = getInputBorderAndBackgroundClasses(shouldShowServerError, isRequired !== null && isRequired !== void 0 ? isRequired : false, isEmpty !== null && isEmpty !== void 0 ? isEmpty : false);
  var toggleOpen = function toggleOpen(open) {
    if (disabled) return;
    setIsOpen(open);
    onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
  };

  // Close dropdown when clicking outside
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        toggleOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Use custom hook to handle dropdown scrolling
  useDropdownScroll(isOpen, containerRef);
  var handleToggleOption = function handleToggleOption(optionValue) {
    var newValue = safeValue.some(function (v) {
      return String(v) === String(optionValue);
    }) ? safeValue.filter(function (item) {
      return String(item) !== String(optionValue);
    }) : [].concat(_toConsumableArray(safeValue), [optionValue]);
    onChange(newValue);
  };
  var handleClear = function handleClear(e) {
    e.preventDefault();
    e.stopPropagation();
    onChange([]);
  };
  var displayValue = safeValue.length > 0 ? safeValue.map(function (v) {
    var _options$find;
    return ((_options$find = options.find(function (o) {
      return String(o.value) === String(v);
    })) === null || _options$find === void 0 ? void 0 : _options$find.label) || v;
  }).join(", ") : placeholder;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative w-full",
    ref: containerRef
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return toggleOpen(!isOpen);
    },
    className: classNames("w-full h-[40px] px-4 py-3 border rounded-lg text-gray-900 dark:text-white flex justify-between items-center", {
      "opacity-60 cursor-not-allowed": disabled,
      "cursor-pointer": !disabled,
      "ring-1 ring-teal-500 border border-teal-500 dark:border-teal-400": isOpen
    }, !isOpen && borderAndBackgroundClasses)
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("truncate flex-1 mr-2", {
      "text-gray-500 dark:text-gray-400": safeValue.length === 0
    })
  }, displayValue), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, safeValue.length > 0 && !disabled && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClear,
    className: "flex items-center text-gray-500 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none",
    "aria-label": "Clear all selections"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "sm"
  })), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isOpen ? faChevronUp : faChevronDown,
    className: "h-4 text-gray-500 dark:text-gray-400"
  }))), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "absolute z-10 w-full mt-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 shadow-lg max-h-60 overflow-y-auto"
  }, options.map(function (option) {
    var isSelected = safeValue.some(function (v) {
      return String(v) === String(option.value);
    });
    return /*#__PURE__*/React.createElement("div", {
      key: option.value,
      onClick: function onClick() {
        return handleToggleOption(option.value);
      },
      className: "flex items-center gap-3 px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer transition-colors"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-5 h-5 rounded border-2 flex items-center justify-center ".concat(isSelected ? "bg-teal-500 border-teal-500" : "border-gray-400 dark:border-gray-500 bg-transparent")
    }, isSelected && /*#__PURE__*/React.createElement("svg", {
      className: "w-3 h-3 text-white",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M5 13l4 4L19 7"
    }))), /*#__PURE__*/React.createElement("span", {
      className: "text-[14px] text-gray-900 dark:text-white"
    }, option.label));
  })), shouldShowServerError && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 ml-2 text-left text-red-500 dark:text-red-400 text-sm"
  }, errorMessage));
};
export default MultiSelectInput;